import { FunctionComponent } from 'react'

import styled from 'styled-components'

import { baseColors, Text } from '@fairhq/common'

import { CharlieLogomark } from './assets/CharlieLogomark'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: ${baseColors.contentContent};
  svg {
    flex-shrink: 0;
  }
`

const StyledText = styled(Text)`
  position: absolute;
  font-family: Gilbert, sans-serif;
`

interface CharlieBenchmarkProps {
  benchmark: number
}

export const CharlieBenchmark: FunctionComponent<CharlieBenchmarkProps> = ({
  benchmark,
}) => (
  <Wrapper>
    <CharlieLogomark />
    <StyledText element="span" type="body" size="sm" fontWeight={400}>
      {`${benchmark}%`}
    </StyledText>
  </Wrapper>
)
